/* unplugin-vue-components disabled */import { render } from "./AdCard2.vue?vue&type=template&id=376ca396&scoped=true"
import script from "./AdCard2.vue?vue&type=script&lang=js"
export * from "./AdCard2.vue?vue&type=script&lang=js"

import "./AdCard2.vue?vue&type=style&index=0&id=376ca396&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376ca396"]])

export default __exports__